import { Routing } from "../pages";

import "./index.css";

const App = () => <Routing />;

export default App;
